import React, {FC} from 'react';
import Progress from './Progress';
import ReassignPopup from './reassign/ReassignPopup';
import TaskDetailsPopup from './task_details/TaskDetailsPopup';
import {CurrentTask} from '../../../types';

type CurrentTaskInfoProps = {
  task: CurrentTask,
  isCurrentUserAssignee: boolean,
  isRunning: boolean,
  isWideProgressBar?: boolean,
  onChangeProgressBarStateCallback: (state: string) => void,
  alertRange: Nullable<number>
}

const CurrentTaskInfo: FC<CurrentTaskInfoProps> = ({
  task,
  alertRange,
  onChangeProgressBarStateCallback,
  isCurrentUserAssignee,
  isRunning,
  isWideProgressBar
}) => {
  const {
    targetTime, startedAt, status, completedAt,
    type, scripts, id: taskId, additionalData
  } = task || {};
  const {detailedDesc, description} = type || {};

  return (
    <div className="current-task-info">
      <Progress
        startedAt={startedAt}
        completedAt={completedAt}
        targetTime={targetTime}
        alertRange={alertRange}
        status={status}
        isWideProgressBar={isWideProgressBar}
        onChangeProgressBarStateCallback={onChangeProgressBarStateCallback}
      />

      <h4 className="current-task-info__title">{description}</h4>

      <div className="current-task-info__container">
        <TaskDetailsPopup
          scripts={scripts}
          detailedDesc={detailedDesc}
          additionalData={additionalData}
        />

        <ReassignPopup
          taskId={taskId}
          isRunning={isRunning}
          isCurrentUserAssignee={isCurrentUserAssignee}
        />
      </div>
    </div>
  );
};

export default CurrentTaskInfo;
